export default function PHP_stripcslashes() {
  return (
    <div>
      <h1>PHP_stripcslashes</h1>
    </div>
  );
}
